import React, { useEffect, useState } from "react";
import { useParams, Outlet } from "react-router-dom";
import PlanList from '../plan-list'
import { useDispatch, useSelector } from 'react-redux';

import * as Svg from "../../../components/svg";
import { getPlanDetail } from "../../../slices/plans";

export const PlanContainer = () => {

    const dispatch = useDispatch()
    const [showPlanDetail, setShowPlanDetail] = useState(false)
    let { planId } = useParams();

    useEffect(() => {
        if (planId) {
            Promise.resolve(dispatch(getPlanDetail({ planId: planId })))
            .then(() => setShowPlanDetail(true))
        } else {
            setShowPlanDetail(false)
        }
    }, [planId])


    return (
        <>
            <div className="left narrow">
                <PlanList callBack={setShowPlanDetail} />
            </div>
            <div className={`position-relative right ${showPlanDetail ? 'show-column' : ''}`}>
                <div className="d-flex d-xl-none align-items-center justify-content-center close-container" onClick={() => setShowPlanDetail(false)}>
                    <Svg.SvgBackarrow />
                    {gettext('Transactions')}
                </div>
                <Outlet />
            </div>
        </>
    )

}

export default PlanContainer